import { useMemo } from 'react';
import useWindowSize from '../../Common/_hooks/useWindowSize';
import { LAB_TEMPLATE_WIDTH } from '../../config';
import { useTheme } from '@mui/material';
import { useSearchParams } from 'react-router';

const MIN_PREVIEW_WIDTH = 380;

//TODO: Should figure out a better way to handle that
const DESKTOP_TOP_BAR_HEIGHT = 64 + 10;
const MOBILE_TOP_BAR_HEIGHT = 52 + 10;
const MOBILE_TOP_BAR_WITH_SELECTOR_HEIGHT = 52 + 40 + 10;
const SAVE_BAR_HEIGHT = 270;
const MOBILE_SAVE_BAR_HEIGHT = 316 + 15;
const MIN_SAVE_BAR_WIDTH = 340;

export default function usePreviewSize() {
    const windowSize = useWindowSize();
    const theme = useTheme();
    const [searchParams] = useSearchParams();
    const isEditing = searchParams.has('design');

    const previewSize = useMemo(() => {
        const topBarHeight = windowSize.width < theme.breakpoints.values.md
            ? (isEditing ? MOBILE_TOP_BAR_HEIGHT : MOBILE_TOP_BAR_WITH_SELECTOR_HEIGHT)
            : DESKTOP_TOP_BAR_HEIGHT;
        let viewerSize = windowSize.width*0.4;
        viewerSize = Math.min(windowSize.height - SAVE_BAR_HEIGHT - topBarHeight, viewerSize);
        viewerSize = Math.min(windowSize.width - LAB_TEMPLATE_WIDTH, viewerSize);
        viewerSize = Math.max(MIN_PREVIEW_WIDTH, viewerSize);

        if(windowSize.width <= theme.breakpoints.values.lab_mobile || windowSize.height < theme.height_breakpoints.values.lab_mobile) {
            viewerSize = Math.min(windowSize.height - MOBILE_SAVE_BAR_HEIGHT - topBarHeight, windowSize.width);

            if(windowSize.height < theme.height_breakpoints.values.lab_mobile && windowSize.width >= 700) {
                viewerSize = Math.min(windowSize.height - topBarHeight - 15, windowSize.width - MIN_SAVE_BAR_WIDTH);
            }
        }

        viewerSize = Math.round(viewerSize);

        return {
            width: viewerSize,
            height: viewerSize,
        }
    }, [isEditing, windowSize, theme])

    return previewSize;
}
